import axios from "../axiosConfig";

class Routes {

    getAllPhases = () => {
        let data = axios.get("/api/phases/")
        return data;
    };
    getPhaseById=(id)=>{
        let data = axios.get(`/api/phases/get/${id}`);
        return data;
      
    };
    createPhase  = (val) => {
        let data = axios.post("/api/phases/", val)
        return data;
    };
    UpdatePhase  = (val) => {
        const data = axios.post(`/api/phases/`,val)
        return data
    };
    deletePhase  = (id) => {
        const data = axios.delete(`/api/phases/${id}`)
        return data
    };


}



export default new Routes();
